import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import SavedViewUpdatesAsideQuery, {
	type SavedViewUpdatesAsideQuery as SavedViewUpdatesAsideQueryType,
} from '../SavedViewUpdates/__generated__/SavedViewUpdatesAsideQuery.graphql';

export const savedViewUpdatesAsideResource: RouteResource<
	PreloadedQuery<SavedViewUpdatesAsideQueryType, Record<string, unknown>>
> = createRelayResource<SavedViewUpdatesAsideQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: SavedViewUpdatesAsideQuery,
			variables: {
				workspaceUuid: context.workspace?.UUID || '',
				viewUuid: routerContext.match.params.uuid || '',
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
